import { z } from 'zod';

export const TemplateFormValuesSchema = z.object({
  isActive: z.boolean(),
  description: z.string(),
  businessProcess: z.string().min(1),
  templateName: z.string().min(3),
  applyRules: z.object({
    paymentType: z.string(),
  }),
});

export const StagesConstructorChecklistAttributeSchema = z.object({
  value: z.boolean(),
  isRequired: z.boolean(),
  name: z.string().min(3),
});

export const StagesConstructorEntitySchema = z.object({
  id: z.string().uuid().nullable(),
  name: z.string().min(3),
  winProbability: z.number().nullable(),
  checklist: z.array(StagesConstructorChecklistAttributeSchema),
  recipients: z.array(
    z.object({
      name: z.string(),
      userProfileId: z.string().uuid().optional(),
      role: z.enum(['SALES_MANAGER', 'SALES_REP', 'FINANCE_MANAGER']).optional(),
    })
  ),
});

export const StagesConstructorListingSchema = z.object({
  bodyFields: z.array(StagesConstructorEntitySchema),
});
